const state = {
  categoryID: '',
};

const mutations = {
  SET_categoryID: (state, id) => {
    state.categoryID = id;
  },
};

const actions = {
  setCategoryID({ commit }, id) {
    commit('SET_categoryID', id);
  },
};

const getters = {
  categoryID: (state) => state.categoryID,
};

export default {
  namespaced: true, // 必须开启：避免命名冲突
  state,
  mutations,
  actions,
  getters,
};
